import { Route } from 'react-router-dom';
import { RequireAdmin } from '../../../common/SharedComponents';

import NoticesLanding from '../../../notices/NoticesLanding';

export default function NoticesRoutes() {
    return (
        <>
            <Route
                path='/notices'
                element={
                    <RequireAdmin>
                        <NoticesLanding />
                    </RequireAdmin>
                }
            />
        </>
    );
}
